{
	"App Settings": {
		"Notes": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "callMonitorUrl:\t\t\tcallMonitorUrl is express server that creates the softphone and listens for invites\n\t\t\t\t\t\t - get status to initiate phone\n\t\t\t\t\t\t - clear to suspend transcriptions\n\t\t\t\t\t\thttps://duck.ngrok.io/status\n\t\t\t\t\t\thttps://vns-firm.uc.r.appspot.com/status\nfaWhatever:\t\t\t\tfollowupActions for firms. Parameters go through a tryEval on the client side.\npublishSettings:\t\tThis is where we keep settings for manually initiating a publish operation.  This is a post to github\n\t\t\t\t\t\tthat triggers a workflow that will rebuild the site and push it to firebase hosting. We also got some\n\t\t\t\t\t\tother settings in there - see the Notes.\nrcAccountSettings:\t\tAll the ring central call manager account settings for message stores specifically - see notes under setting.\nversion:\t\t\t\tMonitored by clients.  When not matching client version, client is prompted to reload for a new version.\nwebSocketAvailable:\t\twebSocketAvailable is used by the node express server to let clients know they have a socket available\n\t\t\t\t\t\tto connect to.\n\t\t\t\t\t\t - this value is set by the node express server\nwebSocketUrl:\t\t\ttriggers the clients to attempt connecting to a websocket server at the url specified\n\t\t\t\t\t\t - both the webSocketAvailable and webSocketUrl need to be set for clients to attempt connection\n\t\t\t\t\t\twss://duck.ngrok.io/ws\n\t\t\t\t\t\twss://vns-firm.uc.r.appspot.com/ws\t\t"
		},
		"adminLoginPageContent": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "## Welcome to the Admin Portal\n\nThis is your digital cockpit — where mere mortals become web legends.\n\nFrom here, you can manage site content, send out envelopes (without the postage), assign roles (cue the dramatic music), and publish updates like the digital overlord you were always meant to be.\n\nWhether you're tweaking a headline, uploading a banner, or granting someone the sacred power of \"Admin Access,\" this is your command center.\n\nLog in below to get started. Just don’t forget your coffee — great things are ahead. ☕"
		},
		"appBuild": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "50"
		},
		"appVersion": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "2.1.22"
		},
		"buildVersion": {
			"permission": "Admin",
			"type": "TextInput",
			"value": "52"
		},
		"dbSubmissions": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "(() => () => {\n\tconst getContent = r => {\n\t\tconst docIds = Object.keys(vns?.store?.submissions?.docs || {})\n\t\t\t.filter((docId) => vns?.getRound?.(docId) === r);\n\t\tconst flds = [\n\t\t\t{\n\t\t\t\tlabel: 'Total Submissions',\n\t\t\t\tfilter: docId => !!docId,\n\t\t\t},\n\t\t\t{\n\t\t\t\tlabel: 'Completed',\n\t\t\t\tfilter: (docId) => vns?.getTags?.(docId)?.length === 0\n\t\t\t},\n\t\t\t{\n\t\t\t\tlabel: 'Incomplete',\n\t\t\t\tfilter: (docId) => vns?.getTags?.(docId)?.length > 0\n\t\t\t},\n\t\t\t{\n\t\t\t\tlabel: 'Missing Essays',\n\t\t\t\tfilter: (docId) => vns?.getTags?.(docId)?.includes('Missing Essay') > 0\n\t\t\t},\n\t\t\t{\n\t\t\t\tlabel: 'Missing Transcripts',\n\t\t\t\tfilter: (docId) => vns?.getTags?.(docId)?.includes('Missing Transcript') > 0\n\t\t\t},\n\t\t\t{\n\t\t\t\tlabel: 'Missing Photos',\n\t\t\t\tfilter: (docId) => vns?.getTags?.(docId)?.includes('Missing Photo') > 0\n\t\t\t},\n\t\t];\n\n\t\tconst headingFlds = [\n\t\t\t{\n\t\t\t\tlabel: \"All Submissions\",\n\t\t\t\tfilter: docId => !!docId,\n\t\t\t},\n\t\t\t{\n\t\t\t\tlabel: \"High School Submissions\",\n\t\t\t\tfilter: docId => vns?.scholarshipSelections?.[vns?.getSubmissionDoc?.(docId)?.['Scholarship Selection']] === 'High School Essay Upload',\n\t\t\t},\n\t\t\t{\n\t\t\t\tlabel: \"College Submissions\",\n\t\t\t\tfilter: docId => vns?.scholarshipSelections?.[vns?.getSubmissionDoc?.(docId)?.['Scholarship Selection']] === 'College Essay Upload',\n\t\t\t},\n\t\t];\n\n\t\tconst topScores = [{ label: \"High School Top Scores\", criteria: 'High School Essay Upload' }, { label: 'College Top Scores', criteria: 'College Essay Upload' }]\n\t\t\t.map(c => ({\n\t\t\t\trecords: docIds\n\t\t\t\t\t.filter(docId => vns?.getTags?.(docId)?.length === 0)\n\t\t\t\t\t.filter(docId => vns?.scholarshipSelections?.[vns?.getSubmissionDoc?.(docId)?.['Scholarship Selection']] === c.criteria)\n\t\t\t\t\t.sort((a, b) => vns?.getPoints(a)?.total > vns?.getPoints(b)?.total ? -1 : 1)\n\t\t\t\t\t.map(docId => ({ docId, score: vns?.getPoints(docId)?.total, label: vns?.getSubmissionIdColumn?.(docId) })),\n\t\t\t\tlabel: c.label\n\t\t\t}));\n\n\t\treturn `<div class=\"flex flex-wrap justify-between\">\n\t\t\t${headingFlds.map(h => `\n\t\t\t\t<div class=\"bg-base-100 rounded-xl m-2 sm:m-4 p-2 sm:p-4 space-y-2 sm:space-y-4\">\n\t\t\t\t\t<h3>${h.label}</h3>\n\t\t\t\t\t${flds.map(f => `<div class=\"flex justify-between\">\n\t\t\t\t\t\t<div>${f.label}</div><div>${docIds.filter(h.filter).filter(f.filter).length}</div>\n\t\t\t\t\t</div>`).join('\\n')}\n\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t`).join('\\n')}\n\t\t\t${topScores.map(t => `<div class=\"bg-base-100 rounded-xl m-2 sm:m-4 p-2 sm:p-4 space-y-2 sm:space-y-4\">\n\t\t\t\t<h3>${t.label}</h3>\n\t\t\t\t<div class=\"w-full max-h-60 overflow-y-scroll space-y-2 sm:space-y-4\">\n\t\t\t\t\t${t.records.map(r => `<div class=\"flex gap-2 sm:gap-4 justify-between items-center\">\n\t\t\t\t\t\t<a href=\"/admin/submissions/?tab=Submissions&docId=${r.docId}\" class=\"block bg-base-100 rounded-xl hover-ripple\">${r.label}</a>\n\t\t\t\t\t\t<div>${r.score}</div>\n\t\t\t\t\t</div>`).join('\\n')}\n\t\t\t\t</div>\n\t\t\t</div>`).join('\\n')}\n\t\t</div>`;\n\t};\n\tconst rounds = [...new Set(Object.keys(vns?.store?.submissions?.docs || []).map(docId => vns.getRound(docId)))].sort((a, b) => vns.rounds[a] > vns.rounds[b] ? -1 : 1);\n\treturn rounds.map(r => `<div class=\"shadow-xl collapse collapse-arrow bg-base-300\">\n\t\t<input type=\"checkbox\" />\n\t\t<h2 class=\"font-medium collapse-title\">${r}</h2>\n\t\t<div class=\"collapse-content\">\n\t\t\t${getContent(r)}\n\t\t</div>\n\t</div>`).join('\\n');\n})();\n"
		},
		"defaultFormLayoutClasses": {
			"permission": "Admin",
			"type": "TextArea",
			"value": "submissions: p-4 grid grid-cols-1 gap-2 md:grid-cols-2 sm:gap-4 bg-base-100"
		},
		"defaultFormLayouts": {
			"permission": "Admin",
			"type": "TextArea",
			"value": "submissions.0.fieldContainerClass: md:grid-cols-2\nsubmissions.0.fieldOrder.0.fieldClass: md:row-span-4\nsubmissions.0.fieldOrder.0.fieldName: Profile Pic\nsubmissions.0.fieldOrder.1.fieldName: Name\nsubmissions.0.fieldOrder.2.fieldName: Date Submitted\nsubmissions.0.fieldOrder.3.fieldName: Address\nsubmissions.0.fieldOrder.4.fieldName: Date of Birth\nsubmissions.0.fieldOrder.5.fieldName: Email Address\nsubmissions.0.fieldOrder.6.fieldName: Phone\nsubmissions.0.groupClass: p-2 sm:p-4 bg-base-300 rounded-xl\nsubmissions.0.id: 5b3eecd7-8192-43da-80b4-9aedbc711cd8\nsubmissions.0.label: Applicant\nsubmissions.1.fieldContainerClass: md:grid-cols-2\nsubmissions.1.fieldOrder.0.fieldName: Scholarship Selection\nsubmissions.1.fieldOrder.1.fieldName: Student Status / Year\nsubmissions.1.fieldOrder.2.fieldName: Current School\nsubmissions.1.fieldOrder.3.fieldName: Cumulative GPA\nsubmissions.1.fieldOrder.4.fieldClass: md:col-span-2\nsubmissions.1.fieldOrder.4.fieldName: Points Summary\nsubmissions.1.fieldOrder.5.fieldClass: md:col-span-2\nsubmissions.1.fieldOrder.5.fieldName: Eligibility Checklist\nsubmissions.1.fieldOrder.6.fieldClass: md:col-span-2\nsubmissions.1.fieldOrder.6.fieldName: Consent & Agreement\nsubmissions.1.groupClass: p-2 sm:p-4 bg-base-300 rounded-xl\nsubmissions.1.id: 28539e3f-948a-4f62-bb0e-d4ddff6779b8\nsubmissions.1.label: Application\nsubmissions.2.fieldContainerClass: md:grid-cols-2\nsubmissions.2.fieldOrder.0.fieldClass: md:col-span-2\nsubmissions.2.fieldOrder.0.fieldName: Essay Analysis\nsubmissions.2.fieldOrder.1.fieldClass: md:col-span-2\nsubmissions.2.fieldOrder.1.fieldName: Essay Prompt\nsubmissions.2.fieldOrder.2.fieldClass: md:col-span-2\nsubmissions.2.fieldOrder.2.fieldName: Essay Text\nsubmissions.2.fieldOrder.3.fieldName: Essay Word Count\nsubmissions.2.groupClass: p-2 sm:p-4 bg-base-300 rounded-xl\nsubmissions.2.id: cb662158-0d8a-4b26-9b34-62a744dbdebe\nsubmissions.2.label: Essay\nsubmissions.3.fieldContainerClass: md:grid-cols-2\nsubmissions.3.fieldOrder.0.fieldClass: md:col-span-2\nsubmissions.3.fieldOrder.0.fieldName: Transcript Analysis\nsubmissions.3.fieldOrder.1.fieldClass: md:col-span-2\nsubmissions.3.fieldOrder.1.fieldName: Transcript Text\nsubmissions.3.fieldOrder.2.fieldName: Transcript Word Count\nsubmissions.3.groupClass: p-2 sm:p-4 bg-base-300 rounded-xl\nsubmissions.3.id: e51cbb35-12a7-4401-a98f-904494f3f215\nsubmissions.3.label: Transcript\nsubmissions.4.fieldContainerClass: md:grid-cols-2\nsubmissions.4.fieldOrder.0.fieldClass: md:col-span-2\nsubmissions.4.fieldOrder.0.fieldName: Essay Upload\nsubmissions.4.fieldOrder.1.fieldClass: md:col-span-2\nsubmissions.4.fieldOrder.1.fieldName: Transcript Uploads\nsubmissions.4.fieldOrder.2.fieldClass: md:col-span-2\nsubmissions.4.fieldOrder.2.fieldName: Photo Upload\nsubmissions.4.groupClass: p-2 sm:p-4 bg-base-300 rounded-xl\nsubmissions.4.id: 0bc8a7da-a214-4de9-8256-4e9e266682b9\nsubmissions.4.label: Assets"
		},
		"defaultTableLayouts": {
			"permission": "Admin",
			"type": "TextArea",
			"value": "submissions.columnOrder.0: Submission\nsubmissions.columnOrder.1: Round\nsubmissions.columnOrder.2: Submitted\nsubmissions.columnOrder.3: Submission Count\nsubmissions.columnOrder.4: Total Points"
		},
		"disableDarkTheme": {
			"permission": "Admin",
			"translations": {
				"en": "false"
			},
			"type": "TextInput",
			"value": "false"
		},
		"index": 0,
		"labels": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"appUpdateMessage": {
					"translations": {},
					"value": "A new version of the app is available. Please reload to get the latest features."
				},
				"ratingCountLabel": {
					"translations": {},
					"value": "Total Reviews"
				},
				"relatedArticles": {
					"translations": {},
					"value": "Related Articles"
				},
				"reviewAction": {
					"translations": {},
					"value": "Leave a Review"
				},
				"statTitle": {
					"translations": {},
					"value": "Average User Rating"
				},
				"tableOfContents": {
					"translations": {},
					"value": "Table of Contents"
				}
			}
		},
		"lightThemeOverwrites": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"--color-primary": {
					"translations": {
						"en": "#C4974B"
					},
					"value": "#C4974B"
				},
				"--color-primary-content": {
					"translations": {
						"en": "#000000"
					},
					"value": "#000000"
				}
			}
		},
		"portalLoginPageContent": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "## Welcome to your User Portal\n\nWelcome to your customer portal — your one-stop hub for keeping things moving.\n\nFrom here, you can review documents, complete forms, send signatures, upload files, and check in on anything that needs your attention.\n\nWhether you're signing an envelope, updating your information, or sending us what we need, this is your place to stay connected without the phone-tag marathon.\n\nLog in below to get started. We’ll keep things organized — you bring the coffee. ☕"
		},
		"roles": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"admin": {
					"translations": {},
					"value": "Admin"
				},
				"distribution": {
					"translations": {},
					"value": "Distribution"
				},
				"submissions": {
					"translations": {},
					"value": "Submissions"
				},
				"xDistrubution": {
					"translations": {},
					"value": "XDistribution"
				},
				"xSubmissions": {
					"translations": {},
					"value": "XSubmissions"
				}
			}
		},
		"tfSubmissions": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "(() => {\n\tconst scholarshipSelections = {\n\t\t\"College / Junior College Scholarship\": 'College Essay Upload',\n\t\t\"College / Junior College / Graduate Scholarship\": 'College Essay Upload',\n\t\t\"High School Scholarship\": 'High School Essay Upload'\n\t};\n\tvns.scholarshipSelections = scholarshipSelections;\n\tconst getTags = docId => {\n\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\tconst keys = { 'Photo': 'Photo Upload', 'Essay': scholarshipSelections[doc?.['Scholarship Selection']], 'Transcript': 'Transcript Uploads' };\n\t\tconst tags = Object.entries(keys).map(([k, v]) => !doc?.[v] ? `Missing ${k}` : '').filter(Boolean);\n\t\treturn tags;\n\t};\n\tvns.getTags = getTags;\n\tconst rounds = {\n\t\t[`Dec '25`]: '2001-01-01T00:00:00.000Z',\n\t\t[`June '26`]: '2025-11-15T08:00:00.000Z',\n\t\t[`Dec '26`]: '2026-06-02T08:00:00.000Z',\n\t\t[`June '27`]: '2026-12-19T08:00:00.000Z'\n\t};\n\tvns.rounds = rounds;\n\tconst getRound = (docId) => {\n\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\tconst submitted = doc.submitted;\n\t\tfor (const [round, date] of Object.entries(rounds).sort((a, b) => a.at(1) > b.at(1) ? -1 : 1)) {\n\t\t\tif (new Date(submitted).valueOf() > new Date(date).valueOf()) return round;\n\t\t}\n\t};\n\tvns.getRound = getRound;\n\tconst getRoundField = (docId) => {\n\t\tconst tags = getTags(docId);\n\t\tconst round = getRound(docId);\n\t\tconst completeTag = tags.length > 0 ? 'Incomplete' : 'Complete';\n\t\tconst value = `${round} - ${completeTag}`;\n\t\tconst label = `<div>${value}</div>\\n${tags.map(t => `<div>${t}</div>`).join('\\n')}`;\n\t\treturn label;\n\t};\n\tvns.getRoundField = getRoundField;\n\tconst aiConfig = {\n\t\t'transcriptText': (docId) => ({ col: 'submissions', agent: 'Transcript Analysis' }),\n\t\t'essayText': (docId) => {\n\t\t\tconst essayPrompt = getEssayPrompt(docId);\n\t\t\treturn { col: 'submissions', agent: 'Essay Analysis', essayPrompt: `${essayPrompt}` };\n\t\t}\n\t};\n\tconst handleChange = (event) => {\n\t\tconst input = event?.currentTarget ?? event?.target;\n\t\tif (!input) return;\n\t\tconst docId = input.getAttribute(\"itemId\");\n\t\tconst key = input.getAttribute(\"key\");\n\t\tlet value = input.value ?? \"\";\n\t\tconst updates = vns.util.unflattenObject({ [key]: value });\n\t\tif (key === 'datetime') {\n\t\t\tupdates.date = {\n\t\t\t\tvalue: new Date(value).toISOString()\n\t\t\t};\n\t\t}\n\t\tif (aiConfig[key]) {\n\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\tconst currentValue = vns.util.getObjectField(doc, key.split('.'));\n\t\t\tif (!currentValue && !!value) {\n\t\t\t\tconst request = { docId, [key]: value, ...aiConfig[key](docId) };\n\t\t\t\tupdates.aiResponses = {\n\t\t\t\t\t[request.agent]: {\n\t\t\t\t\t\tcompleted: 'pending...',\n\t\t\t\t\t\trequest\n\t\t\t\t\t}\n\t\t\t\t};\n\t\t\t}\n\t\t}\n\t\tconsole.log({ updates });\n\t\tvns.recordUpdate(\"submissions\", docId, updates);\n\t};\n\tconst getField = f => {\n\t\treturn {\n\t\t\theading: vns.formatHeading(f),\n\t\t\tfunction: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId) || {};\n\t\t\t\tconst dotValue = vns.util.getObjectField(doc, f.split('.'))?.value;\n\t\t\t\tconst v = typeof dotValue !== 'undefined' ? dotValue : (vns.util.getObjectField(doc, f.split('.')) || '(No response submitted)');\n\t\t\t\tif (typeof v === 'string') return v.split('\\n').map(n => `<div class=\"text-wrap\">${n}</div>`).join('\\n');\n\t\t\t\tif (Array.isArray(v)) return v.map(e => `<div class=\"text-wrap\">✅ ${e}</div>`).join('\\n');\n\t\t\t\treturn `<div class=\"text-wrap\">${v}</div>`;\n\t\t\t},\n\t\t\tvalue: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId) || {};\n\t\t\t\tconst dotValue = vns.util.getObjectField(doc, f.split('.'))?.value;\n\t\t\t\treturn typeof dotValue !== 'undefined' ? dotValue : vns.util.getObjectField(doc, f.split('.'));\n\t\t\t},\n\t\t\tuseReadMore: false\n\t\t};\n\t};\n\tconst displayField = l => {\n\t\tconst f = { ...getField(l.label), type: l.type };\n\t\tif (l.type === 'date') f.function = docId => new Date(`${vns.util.getObjectField(vns.getSubmissionDoc(docId), l.label.split('.'))}T00:00`).toLocaleDateString();\n\t\tif (l.type === 'file') f.function = f.value;\n\t\treturn f;\n\t};\n\t// Old Form\n\t// const formName = 'Scholarships';\n\t// New Form\n\tconst formName = 'Scholarship';\n\tconst [settingId, form] = Object.entries(vns?.store?.scholarships?.docs || {}).find(([k, v]) => v.general?.value?.formName?.value === formName);\n\tconst excludeLabels = ['Cumulative GPA', 'Name', 'Current School', 'Email Address', 'Phone'];\n\tconst formQuestions = Object.entries(form)\n\t\t.filter(([k, v]) => v.value?.type?.value === 'section')\n\t\t.sort((a, b) => a[0] < b[0] ? -1 : 1)\n\t\t.flatMap(([k, v]) => v.value?.questions?.value?.split('+||+'))\n\t\t.map(k => Object.entries(vns.store.scholarships.docs[settingId][k].value).reduce((a, [k, v]) => ({ ...a, [k]: v.value }), {}));\n\tconst formLabels = formQuestions\n\t\t.filter(l => !!l.label && !excludeLabels.includes(l.label))\n\t\t.map(l => ({ ...displayField(l) }));\n\tconst scoreColor = comp => comp >= 0.8 ? 'text-success' : comp >= 0.5 ? 'text-warning' : 'text-error';\n\tconst nameBlock = (name, bestComp) => `\n\t\t<div class=\"bg-base-300 p-2 rounded-xl text-wrap ${bestComp === name?.formattedComp ? 'text-info' : ''}\">\n\t\t\t<div class=\"flex justify-between gap-2\">\n\t\t\t\t<div>${name?.value}</div>\n\t\t\t\t<div class=\"${scoreColor(name?.comp)}\">${bestComp === undefined ? '' : ` (${name?.formattedComp})`}</div>\n\t\t\t</div>\n\t\t\t<div class=\"text-xs opacity-80 font-semibold\">${name?.context}</div>\n\t\t</div>\n\t`;\n\tconst dateBlock = (date, bestComp) => `\n\t\t<div class=\"bg-base-300 p-2 rounded-xl text-wrap ${bestComp === date?.formattedComp ? 'text-info' : ''}\">\n\t\t\t<div class=\"flex justify-between gap-2\">\n\t\t\t\t<div>${date?.value}</div>\n\t\t\t\t<div class=\"${scoreColor(date?.comp)}\">${bestComp === undefined ? '' : ` (${date?.formattedComp})`}</div>\n\t\t\t</div>\n\t\t\t<div class=\"text-xs opacity-80 font-semibold\">${date?.context}</div>\n\t\t</div>\n\t`;\n\tconst schoolBlock = (school, bestComp) => `\n\t\t<div class=\"bg-base-300 p-2 rounded-xl text-wrap ${bestComp === school?.formattedComp ? 'text-info' : ''}\">\n\t\t\t<div class=\"flex justify-between gap-2\">\n\t\t\t\t<div>${school?.name} (${school?.properType})</div>\n\t\t\t\t<div class=\"${scoreColor(school?.comp)}\">${bestComp === undefined ? '' : ` (${school?.formattedComp})`}</div>\n\t\t\t</div>\n\t\t\t<div class=\"text-xs opacity-80 font-semibold\">${school?.context}</div>\n\t\t</div>\n\t`;\n\tconst gpaBlock = (gpa, bestComp) => `\n\t\t<div class=\"bg-base-300 p-2 rounded-xl ${bestComp === gpa?.formattedComp ? 'text-info' : ''}\">\n\t\t\t<div class=\"flex justify-between gap-2\">\n\t\t\t\t<div>${gpa?.formattedValue} (${gpa?.label || '(no label identified)'})</div>\n\t\t\t\t<div class=\"${scoreColor(gpa?.comp)}\">${bestComp === undefined ? '' : ` (${gpa?.formattedComp})`}</div>\n\t\t\t</div>\n\t\t\t<div class=\"text-xs opacity-80 font-semibold text-wrap\">${gpa?.context}</div>\n\t\t</div>\n\t`;\n\tconst getBlock = ({ label, value, best, getBlock, bestComp }) => {\n\t\treturn `\n\t\t\t<div class=\"space-y-2\">\n\t\t\t\t<div>${!!label ? `${label}: ` : ''}${value} <span class=\"${scoreColor(best?.comp)}\">(${best?.formattedComp || 'N/A'})</span></div>\n\t\t\t\t${!!best ? getBlock(best, bestComp) : `<div class=\"bg-base-300 p-2 rounded-xl text-xs opacity-80 font-semibold text-wrap\">Item Not Available</div>`}\n\t\t\t</div>\n\t\t`;\n\t};\n\tconst gpaScale = gpa => gpa >= 3.8 ? 15 : gpa >= 3.5 ? 12 : gpa > 3.0 ? 10 : 0;\n\tconst essayLengthScale = len => len >= 1000 ? 5 : len >= 900 ? 3 : 0;\n\tconst getPoints = docId => {\n\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\tconst points = {\n\t\t\tessay: {\n\t\t\t\toriginalityAndInsight: doc?.aiResponses?.['Essay Analysis']?.essayScore?.originalityAndInsight?.score || 0,\t\n\t\t\t\tpersonalStoryImpactMotivation: doc?.aiResponses?.['Essay Analysis']?.essayScore?.personalStoryImpactMotivation?.score || 0,\n\t\t\t\trelevanceToPrompt: doc?.aiResponses?.['Essay Analysis']?.essayScore?.relevanceToPrompt?.score || 0,\n\t\t\t\twritingQuality: doc?.aiResponses?.['Essay Analysis']?.essayScore?.writingQuality?.score || 0,\n\t\t\t},\n\t\t\tapplication: {\n\t\t\t\tgpa: gpaScale(Number(doc['Cumulative GPA'])),\n\t\t\t\tessayLength: essayLengthScale((doc.essayText || '').split(' ').filter(Boolean).length),\n\t\t\t\tphoto: !!doc?.['Photo Upload'] ? 5 : 0,\n\t\t\t}\n\t\t};\n\t\tpoints.essay.total = Object.values(points.essay).reduce((a, b) => a + b, 0);\n\t\tpoints.application.total = Object.values(points.application).reduce((a, b) => a + b, 0);\n\t\tpoints.total = points.essay.total + points.application.total;\n\t\treturn points;\n\t};\n\tvns.getPoints = getPoints;\n\tconst pointsSummary = docId => {\n\t\tconst points = getPoints(docId);\n\t\tvns.points = points;\n\n\t\treturn `<div>\n\t\t\t${Object.entries(points)\n\t\t\t\t.map(([k, v]) => `<div class=\"bg-base-300 p-2 rounded-xl flex justify-between\">\n\t\t\t\t\t<div>${vns.formatHeading(k)}</div><div>${typeof v === 'object' ? v.total : v}</div>\n\t\t\t\t</div>${typeof v === 'object' ? Object.entries(v)\n\t\t\t\t\t\t.filter(([k, v]) => k !== 'total')\n\t\t\t\t\t\t.map(([k, v]) => `\\n<div class=\"ml-4 px-2 flex justify-between\">\n\t\t\t\t\t\t<div>${vns.formatHeading(k)}</div><div>${v}</div>\n\t\t\t\t\t</div>`).join('') : ''}`).join('\\n')}\n\t\t</div>`;\n\t};\n\tconst getEssayPrompt = docId => {\n\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\tconst fld = scholarshipSelections[doc['Scholarship Selection']];\n\t\tconst formName = doc?.formName;\n\t\tconst form = Object.entries(vns?.store?.scholarships?.docs || {}).find(([k, v]) => v.general?.value?.formName?.value === formName)?.at(1);\n\n\t\tconst essayPrompt = Object.entries(form || {})\n\t\t\t.find(([k, v]) => v.value?.label?.value === fld)?.at(1)?.value?.heading?.value;\n\t\treturn `${essayPrompt?.split('**')?.at(1)}`;\n\t};\n\n\tconst getSubmissionIdColumn = docId => {\n\t\tconst image = Object.entries(vns.util.getObjectField(vns.getSubmissionDoc(docId), 'Photo Upload'.split('.')) || {})?.at(0)?.at(1)?.thumbDownloadUrl;\n\t\tconst avatar = image\n\t\t\t? `<img class=\"h-10 w-10 rounded-full object-cover\" src=\"${image}\"></img>`\n\t\t\t: `<svg class=\"h-10 w-10 rounded-full bg-base-300 text-base-content/60\" viewBox=\"0 0 40 40\" role=\"img\" aria-label=\"Anonymous person\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t<circle cx=\"20\" cy=\"15\" r=\"7\" fill=\"currentColor\" opacity=\"0.75\"></circle>\n\t\t\t\t<path d=\"M8 36c1.8-8 6-12 12-12s10.2 4 12 12\" fill=\"currentColor\" opacity=\"0.75\"></path>\n\t\t\t</svg>`;\n\t\treturn `<div class=\"flex gap-2 items-center\">\n\t\t\t<div class=\"h-10 w-10\">${avatar}</div>\n\t\t\t<div>${vns.util.getObjectField(vns.getSubmissionDoc(docId), 'Name'.split('.'))}</div>\n\t\t</div>`;\n\t};\n\tvns.getSubmissionIdColumn = getSubmissionIdColumn;\n\n\tconst tableFields = [\n\t\t{\n\t\t\t...getField('submissionId'),\n\t\t\theading: 'Submission',\n\t\t\tfunction: getSubmissionIdColumn,\n\t\t\tvalue: docId => vns.util.getObjectField(vns.getSubmissionDoc(docId), 'Name'.split('.')),\n\t\t\tisIdentifier: true\n\t\t},\n\t\t{\n\t\t\t...getField('formName')\n\t\t},\n\t\t{\n\t\t\theading: \"Submitted\",\n\t\t\tfunction: (docId) =>\n\t\t\t\tvns.util.simpleDateTime(vns.getSubmissionDoc(docId)?.submitted),\n\t\t\tvalueFunction: (docId) => vns.getSubmissionDoc(docId)?.submitted,\n\t\t},\n\t\t...formLabels,\n\t\t{\n\t\t\theading: 'Profile Pic',\n\t\t\tfunction: async docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst image = vns.util.getObjectField(doc, 'Photo Upload'.split('.')) || {};\n\t\t\t\tconst file = Object.entries(image)?.at(0)?.at(1);\n\t\t\t\tconst src = !!file?.path ? await vns.getDownloadUrl(file.path) : false;\n\t\t\t\tconst avatar = src\n\t\t\t\t\t? `<img class=\"rounded-xl object-cover\" src=\"${src}\"></img>`\n\t\t\t\t\t: `<svg class=\"rounded-xl bg-base-300 text-base-content/60\" viewBox=\"0 0 40 40\" role=\"img\" aria-label=\"Anonymous person\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t\t\t\t<circle cx=\"20\" cy=\"15\" r=\"7\" fill=\"currentColor\" opacity=\"0.75\"></circle>\n\t\t\t\t\t\t\t<path d=\"M8 36c1.8-8 6-12 12-12s10.2 4 12 12\" fill=\"currentColor\" opacity=\"0.75\"></path>\n\t\t\t\t\t\t</svg>`;\n\t\t\t\treturn `${avatar}`;\n\t\t\t},\n\t\t\tuseReadMore: false,\n\t\t},\n\t\t{\n\t\t\t...getField('Name'),\n\t\t\tfunction: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst name = doc?.['Name'];\n\t\t\t\tconst response = doc?.aiResponses?.['Transcript Analysis'];\n\t\t\t\tif (!response) return name;\n\n\t\t\t\tconst names = (response.transcripts || []).flatMap(t => (t.studentNames || [])).map(n => ({\n\t\t\t\t\t...n,\n\t\t\t\t\tcomp: vns.util.cosineSimilarity(n.value, name),\n\t\t\t\t\tformattedComp: `${(vns.util.cosineSimilarity(n.value, name) * 100).toFixed(0)}%`,\n\t\t\t\t}));\n\t\t\t\tconst bestNameComp = [...names].sort((a, b) => a.comp > b.comp ? -1 : 1)?.at(0)?.formattedComp;\n\t\t\t\tconst bestName = names.find(n => n.formattedComp === bestNameComp);\n\n\t\t\t\treturn getBlock({ value: name, best: bestName, getBlock: nameBlock });\n\t\t\t}\n\t\t},\n\t\t{\n\t\t\t...getField('submitted'),\n\t\t\theading: 'Date Submitted',\n\t\t\tfunction: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst submitted = doc.submitted;\n\t\t\t\tconst date = vns.util.simpleDateTime(submitted);\n\t\t\t\tconst response = doc?.aiResponses?.['Transcript Analysis'];\n\n\t\t\t\tif (!response) return date;\n\n\t\t\t\tconst normalizeDate = d => d?.split('-').slice(0, 2).join('-');\n\t\t\t\tconst dates = (response.transcripts || []).flatMap(t => (t.transcriptDates || [])).map(d => ({\n\t\t\t\t\t...d,\n\t\t\t\t\tcomp: vns.util.cosineSimilarity(normalizeDate(d.isoDate), normalizeDate(submitted)),\n\t\t\t\t\tformattedComp: `${(vns.util.cosineSimilarity(normalizeDate(d.isoDate), normalizeDate(submitted)) * 100).toFixed(0)}%`,\n\t\t\t\t}));\n\t\t\t\tconst bestDateComp = [...dates].sort((a, b) => a.comp > b.comp ? -1 : 1)?.at(0)?.formattedComp;\n\t\t\t\tconst bestDate = dates.find(n => n.formattedComp === bestDateComp);\n\n\t\t\t\treturn getBlock({ value: date, best: bestDate, getBlock: dateBlock });\n\t\t\t}\n\t\t},\n\t\t{\n\t\t\theading: \"Address\",\n\t\t\tfunction: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst addressLines = ['Street Address', 'Street Address Line 2'].map(l => vns.util.getObjectField(doc, l.split('.'))).filter(Boolean);\n\t\t\t\tconst cityStZipLine = ['City', 'State / Province', 'Postal / Zip Code'].map(l => vns.util.getObjectField(doc, l.split('.'))).join(', ');\n\t\t\t\tconst lines = [...addressLines, cityStZipLine];\n\t\t\t\treturn `<div class=\"text-nowrap\">${lines.join('<br />')}</div>`;\n\n\t\t\t},\n\t\t\tvalue: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst addressLines = ['Street Address', 'Street Address Line 2'].map(l => vns.util.getObjectField(doc, l.split('.'))).filter(Boolean);\n\t\t\t\tconst cityStZipLine = ['City', 'State / Province', 'Postal / Zip Code'].map(l => vns.util.getObjectField(doc, l.split('.'))).join(', ');\n\t\t\t\tconst lines = [...addressLines, cityStZipLine];\n\t\t\t\treturn lines.join('\\n');\n\t\t\t},\n\t\t\tuseReadMore: false,\n\t\t},\n\t\t{\n\t\t\t...getField('Email Address'),\n\t\t\tfunction: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst email = vns.util.getObjectField(doc, 'Email Address'.split('.'));\n\n\t\t\t\treturn `<div class=\"text-wrap link hover:cursor-pointer hover-ripple text-primary\">\n\t\t\t\t\t<a class=\"\" href=\"mailto:${email}\">${email}</a>\n\t\t\t\t</div>`;\n\t\t\t}\n\t\t},\n\t\t{\n\t\t\t...getField('Phone'),\n\t\t\tfunction: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst phone = vns.util.getObjectField(doc, 'Phone'.split('.'));\n\n\t\t\t\treturn `<div class=\"text-wrap link hover:cursor-pointer hover-ripple text-primary\">\n\t\t\t\t\t<a href=\"tel:${phone}\">${vns.util.formattedPhone(phone, false)}</a>\n\t\t\t\t</div>`;\n\t\t\t},\n\t\t},\n\t\t{\n\t\t\t...getField('Current School'),\n\t\t\tfunction: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst school = doc?.['Current School'];\n\t\t\t\tconst response = doc?.aiResponses?.['Transcript Analysis'];\n\n\t\t\t\tif (!response) return school;\n\n\t\t\t\tconst schools = (response.transcripts || []).flatMap(t => (t.schools || [])).map(s => ({\n\t\t\t\t\t...s,\n\t\t\t\t\tcomp: vns.util.cosineSimilarity(s.name, school),\n\t\t\t\t\tformattedComp: `${(vns.util.cosineSimilarity(s.name, school) * 100).toFixed(0)}%`,\n\t\t\t\t\tproperType: vns.util.convertToTitleCase(s.type)\n\t\t\t\t}));\n\t\t\t\tconst bestSchoolComp = [...schools].sort((a, b) => a.comp > b.comp ? -1 : 1)?.at(0)?.formattedComp;\n\t\t\t\tconst bestSchool = schools.find(s => s.formattedComp === bestSchoolComp);\n\n\t\t\t\treturn getBlock({ value: school, best: bestSchool, getBlock: schoolBlock });\n\t\t\t}\n\t\t},\n\t\t{\n\t\t\t...getField('Cumulative GPA'),\n\t\t\tfunction: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst gpa = doc['Cumulative GPA'];\n\t\t\t\tconst response = doc?.aiResponses?.['Transcript Analysis'];\n\n\t\t\t\tconst gpas = (response?.transcripts || []).flatMap(t => t.gpas).map(g => ({\n\t\t\t\t\t...g,\n\t\t\t\t\tcomp: vns.util.cosineSimilarity(g.value.toString(), gpa),\n\t\t\t\t\tformattedComp: `${(vns.util.cosineSimilarity(g.value.toString(), gpa) * 100).toFixed(0)}%`,\n\t\t\t\t\tformattedValue: `${g.value}${g.scale !== null ? ` / ${g.scale}` : ''}`,\n\t\t\t\t}));\n\t\t\t\tconst bestGpaComp = [...gpas].sort((a, b) => a.comp > b.comp ? -1 : 1)?.at(0)?.formattedComp;\n\t\t\t\tconst bestGpa = gpas.find(g => g.formattedComp === bestGpaComp);\n\n\t\t\t\treturn getBlock({ value: gpa, best: bestGpa, getBlock: gpaBlock });\n\t\t\t}\n\t\t},\n\t\t{\n\t\t\theading: 'Essay Prompt',\n\t\t\tfunction: getEssayPrompt,\n\t\t\tvalue: getEssayPrompt,\n\t\t\ttype: \"MarkedContent\",\n\t\t\tuseReadMore: false,\n\t\t},\n\t\t{\n\t\t\theading: 'Essay Upload',\n\t\t\tfunction: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst fld = scholarshipSelections[doc['Scholarship Selection']];\n\t\t\t\treturn doc[fld];\n\t\t\t},\n\t\t\tvalue: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst fld = scholarshipSelections[doc['Scholarship Selection']];\n\t\t\t\treturn doc[fld];\n\t\t\t},\n\t\t\ttype: 'file',\n\t\t},\n\t\t{\n\t\t\t...getField('essayText'),\n\t\t\ttype: 'textarea',\n\t\t\tkey: 'essayText',\n\t\t\taction: handleChange,\n\t\t\tfunction: async docId => {\n\t\t\t\tconst fld = getField('essayText');\n\t\t\t\tconst current = fld.value(docId);\n\t\t\t\tif (!current) {\n\t\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\t\tconst f = scholarshipSelections[doc['Scholarship Selection']];\n\t\t\t\t\tconst docs = vns.util.getObjectField(doc, f.split('.'));\n\t\t\t\t\tconst results = await Promise.all(Object.entries(docs || {}).map(async ([k, v]) => await vns.fileToMarkdown(v)));\n\t\t\t\t\tconst suggested = results.join('\\n\\n\\n');\n\t\t\t\t\tconst id = `div-${docId}-essaytext-textarea-input`;\n\t\t\t\t\tconst inputElement = document.getElementById(id);\n\t\t\t\t\tinputElement.value = suggested;\n\t\t\t\t\tinputElement.dispatchEvent(new Event('input', { bubbles: true }));\n\t\t\t\t}\n\t\t\t\treturn current;\n\t\t\t},\n\t\t},\n\t\t{\n\t\t\theading: \"Essay Word Count\",\n\t\t\tfunction: docId => (vns.getSubmissionDoc(docId)?.essayText || '').split(' ').filter(Boolean).length.toLocaleString(),\n\t\t\tvalue: docId => (vns.getSubmissionDoc(docId)?.essayText || '').split(' ').filter(Boolean).length.toLocaleString(),\n\t\t},\n\t\t{\n\t\t\t...getField('transcriptText'),\n\t\t\ttype: 'textarea',\n\t\t\tkey: 'transcriptText',\n\t\t\taction: handleChange,\n\t\t\tfunction: async docId => {\n\t\t\t\tconst fld = getField('transcriptText');\n\t\t\t\tconst current = fld.value(docId);\n\t\t\t\tif (!current) {\n\t\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\t\tconst f = 'Transcript Uploads';\n\t\t\t\t\tconst docs = vns.util.getObjectField(doc, f.split('.'));\n\t\t\t\t\tconst results = await Promise.all(Object.entries(docs || {}).map(async ([k, v]) => await vns.fileToMarkdown(v)));\n\t\t\t\t\tconst transcriptText = results.join('\\n\\n\\n');\n\t\t\t\t\tconst id = `div-${docId}-transcripttext-textarea-input`;\n\t\t\t\t\tconst inputElement = document.getElementById(id);\n\t\t\t\t\tinputElement.value = transcriptText;\n\t\t\t\t\tinputElement.dispatchEvent(new Event('input', { bubbles: true }));\n\t\t\t\t\t// const agent = \"Transcript Analysis\";\n\t\t\t\t\t// const col = 'submissions';\n\t\t\t\t\t// await vns.callAiResponse({ agent, col, docId, transcriptText });\n\t\t\t\t}\n\t\t\t\treturn current;\n\t\t\t},\n\t\t},\n\t\t{\n\t\t\theading: \"Transcript Word Count\",\n\t\t\tfunction: docId => (vns.getSubmissionDoc(docId)?.transcriptText || '').split(' ').filter(Boolean).length.toLocaleString(),\n\t\t\tvalue: docId => (vns.getSubmissionDoc(docId)?.transcriptText || '').split(' ').filter(Boolean).length.toLocaleString(),\n\t\t},\n\t\t{\n\t\t\t...getField('aiResonses.Transcript Analysis'),\n\t\t\theading: 'Transcript Analysis',\n\t\t\tfunction: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst response = doc?.aiResponses?.['Transcript Analysis'];\n\t\t\t\tif (!response) return 'No Analysis Available';\n\n\t\t\t\tconst name = doc?.['Name'];\n\t\t\t\tconst names = (response.transcripts || []).flatMap(t => (t.studentNames || [])).map(n => ({\n\t\t\t\t\t...n,\n\t\t\t\t\tcomp: vns.util.cosineSimilarity(n.value, name),\n\t\t\t\t\tformattedComp: `${(vns.util.cosineSimilarity(n.value, name) * 100).toFixed(0)}%`,\n\t\t\t\t}));\n\t\t\t\tconst bestNameComp = [...names].sort((a, b) => a.comp > b.comp ? -1 : 1)?.at(0)?.formattedComp;\n\t\t\t\tconst bestName = names.find(n => n.formattedComp === bestNameComp);\n\n\t\t\t\tconst normalizeDate = d => d?.split('-').slice(0, 2).join('-');\n\t\t\t\tconst submitted = doc.submitted;\n\t\t\t\tconst date = vns.util.simpleDateTime(submitted);\n\t\t\t\tconst dates = (response.transcripts || []).flatMap(t => (t.transcriptDates || [])).map(d => ({\n\t\t\t\t\t...d,\n\t\t\t\t\tcomp: vns.util.cosineSimilarity(normalizeDate(d.isoDate), normalizeDate(submitted)),\n\t\t\t\t\tformattedComp: `${(vns.util.cosineSimilarity(normalizeDate(d.isoDate), normalizeDate(submitted)) * 100).toFixed(0)}%`,\n\t\t\t\t}));\n\t\t\t\tconst bestDateComp = [...dates].sort((a, b) => a.comp > b.comp ? -1 : 1)?.at(0)?.formattedComp;\n\t\t\t\tconst bestDate = dates.find(n => n.formattedComp === bestDateComp);\n\n\t\t\t\tconst school = doc?.['Current School'];\n\t\t\t\tconst schools = (response.transcripts || []).flatMap(t => (t.schools || [])).map(s => ({\n\t\t\t\t\t...s,\n\t\t\t\t\tcomp: vns.util.cosineSimilarity(s.name, school),\n\t\t\t\t\tformattedComp: `${(vns.util.cosineSimilarity(s.name, school) * 100).toFixed(0)}%`,\n\t\t\t\t\tproperType: vns.util.convertToTitleCase(s.type)\n\t\t\t\t}));\n\t\t\t\tconst bestSchoolComp = [...schools].sort((a, b) => a.comp > b.comp ? -1 : 1)?.at(0)?.formattedComp;\n\t\t\t\tconst bestSchool = schools.find(s => s.formattedComp === bestSchoolComp);\n\n\t\t\t\tconst gpa = doc['Cumulative GPA'];\n\t\t\t\tconst gpas = (response?.transcripts || []).flatMap(t => t.gpas).map(g => ({\n\t\t\t\t\t...g,\n\t\t\t\t\tcomp: vns.util.cosineSimilarity(g.value.toString(), gpa),\n\t\t\t\t\tformattedComp: `${(vns.util.cosineSimilarity(g.value.toString(), gpa) * 100).toFixed(0)}%`,\n\t\t\t\t\tformattedValue: `${g.value}${g.scale !== null ? ` / ${g.scale}` : ''}`,\n\t\t\t\t}));\n\t\t\t\tconst bestGpaComp = [...gpas].sort((a, b) => a.comp > b.comp ? -1 : 1)?.at(0)?.formattedComp;\n\t\t\t\tconst bestGpa = gpas.find(g => g.formattedComp === bestGpaComp);\n\n\t\t\t\treturn `<div class=\"space-y-4 max-h-64 overflow-y-scroll border-2 border-primary p-2 sm:p-4 rounded-xl\">\n\t\t\t\t\t${getBlock({ value: name, best: bestName, getBlock: nameBlock, label: 'Student Name' })}\n\t\t\t\t\t${getBlock({ value: date, best: bestDate, getBlock: dateBlock, label: 'Transcript Date' })}\n\t\t\t\t\t${getBlock({ value: school, best: bestSchool, getBlock: schoolBlock, label: 'School' })}\n\t\t\t\t\t${getBlock({ value: gpa, best: bestGpa, getBlock: gpaBlock, label: 'GPA' })}\n\t\t\t\t\t<div>Detail</div>\n\t\t\t\t\t\t<div class=\"space-y-2\">\n\t\t\t\t\t\t\t<div>Student Name Entries</div>\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t${names.length > 0 ? names.map(n => nameBlock(n, bestNameComp)).join('\\n') : `<div class=\"bg-base-300 p-2 rounded-xl text-xs opacity-80 font-semibold text-wrap\">No Items Found</div>`}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"space-y-2\">\n\t\t\t\t\t\t\t<div>Transcript Date Entries</div>\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t${dates.length > 0 ? dates.map(d => dateBlock(d, bestDateComp)).join('\\n') : `<div class=\"bg-base-300 p-2 rounded-xl text-xs opacity-80 font-semibold text-wrap\">No Items Found</div>`}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"space-y-2\">\n\t\t\t\t\t\t\t<div>School Entries</div>\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t${schools.length > 0 ? schools.map(s => schoolBlock(s, bestSchoolComp)).join('\\n') : `<div class=\"bg-base-300 p-2 rounded-xl text-xs opacity-80 font-semibold text-wrap\">No Items Found</div>`}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"space-y-2\">\n\t\t\t\t\t\t\t<div>Transcript GPA Listings</div>\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t${gpas.length > 0 ? gpas.map(g => gpaBlock(g, bestGpaComp)).join('\\n') : `<div class=\"bg-base-300 p-2 rounded-xl text-xs opacity-80 font-semibold text-wrap\">No Items Found</div>`}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>`;\n\t\t\t},\n\t\t\tvalue: docId => docId,\n\t\t},\n\t\t{\n\t\t\t...getField('aiResponses.Essay Analysis'),\n\t\t\theading: 'Essay Analysis',\n\t\t\tvalue: docId => docId,\n\t\t\tfunction: docId => {\n\t\t\t\tconst levelColor = {\n\t\t\t\t\t'low': 'text-success',\n\t\t\t\t\t'medium': 'text-warning',\n\t\t\t\t\t'high': 'text-error'\n\t\t\t\t};\n\t\t\t\tconst getScoreColor = (p) => p > 0.8 ? 'text-success' : p > 0.5 ? 'text-warning' : 'text-error';\n\t\t\t\tconst ranges = {\n\t\t\t\t\t'total': 75,\n\t\t\t\t\t'relevanceToPrompt': 25,\n\t\t\t\t\t'originalityAndInsight': 20,\n\t\t\t\t\t'writingQuality': 15,\n\t\t\t\t\t'personalStoryImpactMotivation': 15,\n\t\t\t\t};\n\t\t\t\tconst getScore = (k, v) => `<span class=\"${getScoreColor(v / ranges[k])}\">${v} / ${ranges[k]} (${((v / ranges[k]) * 100).toFixed()}%)</span>`;\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst response = doc?.aiResponses?.['Essay Analysis'];\n\t\t\t\tif (!response) return 'No Analysis Available';\n\n\t\t\t\treturn `<div class=\"space-y-4 max-h-64 overflow-y-scroll border-2 border-primary p-2 sm:p-4 rounded-xl\">\n\t\t\t\t\t<div class=\"space-y-2 text-wrap\">\n\t\t\t\t\t\t<div>Warnings: ${response.warnings?.length}</div>\n\t\t\t\t\t\t${response.warnings?.map(w => `<div class=\"bg-base-300 p-2 rounded-xl text-xs opacity-80 font-semibold\">${w}</div>`).join('\\n')}\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"space-y-2 text-wrap\">\n\t\t\t\t\t\t<div>AI Generation Review: <span class=\"${levelColor[response.aiGenerationReview?.concernLevel]}\">${response.aiGenerationReview?.concernLevel} (${response.aiGenerationReview?.concernScore} / 100)</span></div>\n\t\t\t\t\t\t<div>${response.aiGenerationReview?.notes}</div>\n\t\t\t\t\t\t${response.aiGenerationReview?.reasons?.map(r => `<div class=\"bg-base-300 p-2 rounded-xl text-xs opacity-80 font-semibold\">${r}</div>`).join('\\n')}\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"space-y-2 text-wrap\">\n\t\t\t\t\t\t<div>Review: ${response.review?.summary}</div>\n\t\t\t\t\t\t<div>Strengths: ${response.review?.strengths?.length}</div>\n\t\t\t\t\t\t${response.review?.strengths?.map(s => `<div class=\"bg-base-300 p-2 rounded-xl text-xs opacity-80 font-semibold\">${s}</div>`).join('\\n')}\n\t\t\t\t\t\t<div>Concerns: ${response.review?.concerns?.length}</div>\n\t\t\t\t\t\t${response.review?.concerns?.map(s => `<div class=\"bg-base-300 p-2 rounded-xl text-xs opacity-80 font-semibold\">${s}</div>`).join('\\n')}\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"space-y-2 text-wrap\">\n\t\t\t\t\t\t<div>Essay Score: ${getScore('total', response.essayScore?.total)}</div>\n\t\t\t\t\t\t${Object.entries(response.essayScore || {}).filter(([k, v]) => v.score !== undefined).map(([k, v]) => `<div class=\"bg-base-300 p-2 rounded-xl\">\n\t\t\t\t\t\t\t<div>${vns.formatHeading(k)} ${getScore(k, v.score)}</div>\n\t\t\t\t\t\t\t<div class=\"text-xs opacity-80 font-semibold\">${v.notes}</div>\n\t\t\t\t\t\t</div>`).join('\\n')}\n\t\t\t\t\t</div>\n\t\t\t\t</div>`;\n\t\t\t},\n\t\t},\n\t\t{\n\t\t\theading: \"Points Summary\",\n\t\t\tfunction: docId => pointsSummary(docId),\n\t\t\tvalue: docId => docId,\n\t\t\tuseReadMore: false,\n\t\t},\n\t\t{\n\t\t\theading: \"Total Points\",\n\t\t\tfunction: docId => getPoints(docId).total,\n\t\t\tvalue: docId => getPoints(docId).total,\n\t\t},\n\t\t{\n\t\t\theading: \"Round\",\n\t\t\tfunction: docId => getRoundField(docId),\n\t\t\tvalue: docId => getRoundField(docId),\n\t\t},\n\t\t{\n\t\t\theading: \"Submission Count\",\n\t\t\tfunction: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst email = doc['Email Address'];\n\t\t\t\tif (!email) return 0;\n\t\t\t\tconst emailList = Object.entries(vns.store.submissions.docs || {}).map(([k, v]) => v['Email Address']);\n\t\t\t\treturn emailList.filter(e => e === email).length;\n\t\t\t},\n\t\t\tvalue: docId => {\n\t\t\t\tconst doc = vns.getSubmissionDoc(docId);\n\t\t\t\tconst email = doc['Email Address'];\n\t\t\t\tif (!email) return 0;\n\t\t\t\tconst emailList = Object.entries(vns.store.submissions.docs || {}).map(([k, v]) => v['Email Address']);\n\t\t\t\treturn emailList.filter(e => e === email).length;\n\t\t\t},\n\t\t}\n\t];\n\treturn tableFields;\n})();\n"
		},
		"themeCustomizations": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "body {\n\tdirection: ltr;\n\ttext-align: left;\n\tfont-family: 'Barlow Condensed', sans-serif;\n}\nh1 {\n\t@apply uppercase font-semibold\n}\n"
		},
		"themeImports": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "@import '@fontsource/barlow-condensed';"
		}
	},
	"Features Social Media Component": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"action": {
					"translations": {},
					"value": "actionFacebook"
				}
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"action": {
					"translations": {},
					"value": "actionLinkedIn"
				}
			}
		},
		"Feature 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"action": {
					"translations": {},
					"value": "actionInstagram"
				}
			}
		},
		"actionFacebook": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {},
					"value": "https://www.facebook.com/sevenslegalapc/"
				}
			}
		},
		"actionFacebookIcon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fab\",\"iconName\":\"facebook\",\"icon\":[512,512,[62000],\"f09a\",\"M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5l0-170.3-52.8 0 0-78.2 52.8 0 0-33.7c0-87.1 39.4-127.5 125-127.5 16.2 0 44.2 3.2 55.7 6.4l0 70.8c-6-.6-16.5-1-29.6-1-42 0-58.2 15.9-58.2 57.2l0 27.8 83.6 0-14.4 78.2-69.3 0 0 175.9C413.8 494.8 512 386.9 512 256z\"]}",
				"name": "faFacebook"
			}
		},
		"actionInstagram": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {},
					"value": "https://instagram.com/sevenslegal/"
				}
			}
		},
		"actionInstagramIcon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fab\",\"iconName\":\"instagram\",\"icon\":[448,512,[],\"f16d\",\"M224.3 141a115 115 0 1 0 -.6 230 115 115 0 1 0 .6-230zm-.6 40.4a74.6 74.6 0 1 1 .6 149.2 74.6 74.6 0 1 1 -.6-149.2zm93.4-45.1a26.8 26.8 0 1 1 53.6 0 26.8 26.8 0 1 1 -53.6 0zm129.7 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM399 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z\"]}",
				"name": "faInstagram"
			}
		},
		"actionLinkedIn": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {},
					"value": "https://www.linkedin.com/company/sevens-legal"
				}
			}
		},
		"actionLinkedInIcon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fab\",\"iconName\":\"square-linkedin\",\"icon\":[448,512,[],\"e7d0\",\"M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm5 170.2l66.5 0 0 213.8-66.5 0 0-213.8zm71.7-67.7a38.5 38.5 0 1 1 -77 0 38.5 38.5 0 1 1 77 0zM317.9 416l0-104c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9l0 105.8-66.4 0 0-213.8 63.7 0 0 29.2 .9 0c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9l0 117.2-66.4 0z\"]}",
				"name": "faSquareLinkedin"
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionFacebookClass": {
					"translations": {},
					"value": "btn btn-ghost hover-ripple rounded-xl text-3xl p-2"
				},
				"actionInstagramClass": {
					"translations": {},
					"value": "btn btn-ghost hover-ripple rounded-xl text-3xl p-2"
				},
				"actionLinkedInClass": {
					"translations": {},
					"value": "btn btn-ghost hover-ripple rounded-xl text-3xl p-2"
				}
			}
		},
		"index": 1,
		"test": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fab\",\"iconName\":\"youtube\",\"icon\":[576,512,[61802],\"f167\",\"M549.7 124.1C543.5 100.4 524.9 81.8 501.4 75.5 458.9 64 288.1 64 288.1 64S117.3 64 74.7 75.5C51.2 81.8 32.7 100.4 26.4 124.1 15 167 15 256.4 15 256.4s0 89.4 11.4 132.3c6.3 23.6 24.8 41.5 48.3 47.8 42.6 11.5 213.4 11.5 213.4 11.5s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zM232.2 337.6l0-162.4 142.7 81.2-142.7 81.2z\"]}",
				"name": "faYoutube"
			}
		},
		"title": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "Follow Us On"
		}
	},
	"Footer": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"footerClass": {
					"translations": {},
					"value": "relative bg-[#404040]"
				},
				"servicesContentClass": {
					"translations": {},
					"value": "mb-2 sm:mb-2"
				}
			}
		},
		"copyrightTag": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "All Rights Reserved"
		},
		"disclaimers": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "This website is for informational purposes only and does not constitute legal advice or create an attorney-client relationship. Past results do not guarantee future outcomes. Awards or recognitions are for informational purposes only and may be based on subjective criteria. For legal advice, contact our office directly. [Full Disclaimer](https://www.sevenslegal.com/disclaimer/)"
		},
		"footerReview": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"ratingCountLabel": {
					"translations": {
						"en": "Total Reviews"
					},
					"value": "Total Reviews"
				},
				"reviewAction": {
					"translations": {
						"en": "Leave A Review"
					},
					"value": "Leave A Review"
				},
				"statTitle": {
					"translations": {
						"en": "Average User Rating"
					},
					"value": "Average User Rating"
				}
			}
		},
		"footerTheme": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "dark"
		},
		"index": 2,
		"servicesContentClass": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput"
		},
		"showGoogleReviews": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		},
		"useMainLocationDetails": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		},
		"usePrimaryBg": {
			"permission": "Admin",
			"translations": {
				"en": "false"
			},
			"type": "TextInput",
			"value": "false"
		}
	},
	"Head": {
		"defaultIcon": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"en": "Sevens Legal Icon"
					},
					"value": "Sevens Legal Icon"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/sevens-legal.firebasestorage.app/o/uploads%2Fsettings%2FHead%2FdefaultIcon%2Foutput.png?alt=media&token=e65b2713-a2c4-4b76-90c0-25429cb72bbe",
				"formattedSize": "10.57 KB",
				"height": 190,
				"name": "output.png",
				"path": "uploads/settings/Head/defaultIcon/output.png",
				"query": "?as=run",
				"size": 10826,
				"type": "image/png",
				"updated": "2025-09-05T03:16:04.301Z",
				"width": 203
			}
		},
		"index": 3
	},
	"Header": {
		"Menu 00": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"hide": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"href": {
					"translations": {
						"en": "/"
					},
					"value": "/"
				},
				"label": {
					"translations": {
						"en": "Home"
					},
					"value": "Scholarships"
				}
			}
		},
		"Menu 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"en": "https://www.sevenslegal.com/sevens-legal-attorneys/"
					},
					"value": "https://www.sevenslegal.com/sevens-legal-attorneys/"
				},
				"label": {
					"translations": {
						"en": "Attorneys"
					},
					"value": "Attorneys"
				}
			}
		},
		"Menu 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"en": "https://www.sevenslegal.com/criminal-lawyer/"
					},
					"value": "https://www.sevenslegal.com/criminal-lawyer/"
				},
				"label": {
					"translations": {
						"en": "Criminal Law"
					},
					"value": "Criminal Law"
				}
			}
		},
		"Menu 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"en": "https://www.sevenslegal.com/testimonials/"
					},
					"value": "https://www.sevenslegal.com/testimonials/"
				},
				"label": {
					"translations": {
						"en": "Testimonials"
					},
					"value": "Testimonials"
				}
			}
		},
		"Menu 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"en": "Cities"
					},
					"value": "Cities"
				},
				"opStr": {
					"translations": {
						"en": "type, ==, TextObject"
					},
					"value": "src.type, ==, TextObject"
				},
				"optionHref": {
					"translations": {
						"en": "src.link.value"
					},
					"value": "src.value.link.value"
				},
				"optionLabel": {
					"translations": {
						"en": "src.label"
					},
					"value": "src.value.label"
				},
				"options": {
					"translations": {
						"en": "settings, cities"
					},
					"value": "settings, cities"
				}
			}
		},
		"Menu 05": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"en": "https://www.sevenslegal.com/blog/"
					},
					"value": "https://www.sevenslegal.com/blog/"
				},
				"label": {
					"translations": {
						"en": "Blog"
					},
					"value": "Blog"
				}
			}
		},
		"Menu 06": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"en": "https://www.sevenslegal.com/contact/"
					},
					"value": "https://www.sevenslegal.com/contact/"
				},
				"label": {
					"translations": {
						"en": "Contact"
					},
					"value": "Contact"
				}
			}
		},
		"Menu 11": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"hide": {
					"translations": {},
					"value": "true"
				},
				"href": {
					"translations": {},
					"value": "/portal/"
				},
				"label": {
					"translations": {},
					"value": "Login"
				}
			}
		},
		"Menu 12": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"hide": {
					"translations": {},
					"value": "true"
				},
				"href": {
					"translations": {},
					"value": "/portal/"
				},
				"label": {
					"translations": {},
					"value": "Portal"
				},
				"opStr": {
					"translations": {},
					"value": "src.type, ==, TextObject"
				},
				"optionHref": {
					"translations": {},
					"value": "lang, area, src.value.path.value, src.value.endpoint.value"
				},
				"optionLabel": {
					"translations": {},
					"value": "src.value.label"
				},
				"optionQuery": {
					"translations": {},
					"value": "src.value.params.value"
				},
				"options": {
					"translations": {},
					"value": "settings, portalMenus"
				}
			}
		},
		"Menu 13": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"hide": {
					"translations": {},
					"value": "userRoles.submissions, in, , undefined, false"
				},
				"href": {
					"translations": {},
					"value": "/admin/"
				},
				"label": {
					"translations": {},
					"value": "Submissions"
				},
				"opStr": {
					"translations": {},
					"value": "src.type, ==, TextObject"
				},
				"optionHref": {
					"translations": {},
					"value": "lang, area, src.value.path.value, src.value.endpoint.value"
				},
				"optionLabel": {
					"translations": {},
					"value": "src.value.label"
				},
				"optionQuery": {
					"translations": {},
					"value": "src.value.params.value"
				},
				"options": {
					"translations": {},
					"value": "settings, submissionsMenus"
				}
			}
		},
		"Menu 21": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"hide": {
					"translations": {},
					"value": "userRoles.admin, in, , undefined, false"
				},
				"href": {
					"translations": {},
					"value": "/admin/"
				},
				"label": {
					"translations": {},
					"value": "Admin"
				},
				"opStr": {
					"translations": {},
					"value": "src.type, ==, TextObject"
				},
				"optionHref": {
					"translations": {},
					"value": "lang, area, src.value.path.value, src.value.endpoint.value"
				},
				"optionLabel": {
					"translations": {},
					"value": "src.value.label"
				},
				"optionQuery": {
					"translations": {},
					"value": "src.value.params.value"
				},
				"options": {
					"translations": {},
					"value": "settings, adminMenus"
				}
			}
		},
		"banner": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {},
					"value": "/"
				}
			}
		},
		"bannerColor": {
			"permission": "Admin",
			"translations": {
				"en": "#ffffff"
			},
			"type": "TextInput",
			"value": "#ffffff"
		},
		"bannerImageDark": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Sevens Legal Logo"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/sevens-legal.firebasestorage.app/o/uploads%2Fsettings%2FHeader%2FbannerImageDark%2Fsevens-legal-horizontal-logo-champagne-large-no-margins.png?alt=media&token=39bf4ffe-f659-462c-9cf1-50a95bb698d3",
				"formattedSize": "55.93 KB",
				"height": 750,
				"name": "sevens-legal-horizontal-logo-champagne-large-no-margins.png",
				"path": "uploads/settings/Header/bannerImageDark/sevens-legal-horizontal-logo-champagne-large-no-margins.png",
				"query": "?w=640&as=run:0",
				"size": 57268,
				"type": "image/png",
				"updated": "2026-06-26T16:17:39.363Z",
				"width": 3749
			}
		},
		"bannerImageLight": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Sevens Legal Logo"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/sevens-legal.firebasestorage.app/o/uploads%2Fsettings%2FHeader%2FbannerImageLight%2Fsevens-legal-criminal-lawyers-new-logo-2024.png?alt=media&token=92fe2d4a-e201-492d-ada3-5fc936cde11a",
				"formattedSize": "22.27 KB",
				"height": 244,
				"name": "sevens-legal-criminal-lawyers-new-logo-2024.png",
				"path": "uploads/settings/Header/bannerImageLight/sevens-legal-criminal-lawyers-new-logo-2024.png",
				"query": "?w=640&as=run:0",
				"size": 22803,
				"type": "image/png",
				"updated": "2026-06-26T16:18:18.682Z",
				"width": 1016
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bannerClass": {
					"translations": {},
					"value": "cursor-pointer inline-block my-auto relative w-80"
				},
				"bannerImageClass": {
					"translations": {},
					"value": "relative"
				}
			}
		},
		"index": 4,
		"usePrimaryBg": {
			"permission": "Admin",
			"translations": {
				"en": "false"
			},
			"type": "TextInput",
			"value": "false"
		}
	},
	"Publish": {
		"Notes": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "maxUpdateCount is the total number of urls to update each day\ncheckUrlInterval is interval in minutes for how often a check will be done with the above number of urls"
		},
		"activeBranch": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "main"
		},
		"channelId": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "live"
		},
		"index": 5
	},
	"adminMenus": {
		"Menu 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"en": "Scholarships"
					},
					"value": "Scholarships"
				},
				"params": {
					"translations": {
						"en": "col=scholarships"
					},
					"value": "col=scholarships"
				},
				"path": {
					"translations": {
						"en": "admin"
					},
					"value": "admin"
				}
			}
		},
		"Menu 21": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Settings"
				},
				"params": {
					"translations": {},
					"value": "col=settings"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 22": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Locations"
				},
				"params": {
					"translations": {},
					"value": "col=locations"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 23": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"cols": {
					"translations": {},
					"value": "submissions"
				},
				"endpoint": {
					"translations": {},
					"value": "submissions"
				},
				"label": {
					"translations": {},
					"value": "Submissions"
				},
				"path": {
					"translations": {},
					"value": "admin"
				},
				"tabs": {
					"translations": {},
					"value": "Submissions"
				}
			}
		},
		"Menu 24": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {},
					"value": "operations"
				},
				"label": {
					"translations": {},
					"value": "Operations"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 25": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {},
					"value": "roles"
				},
				"label": {
					"translations": {},
					"value": "Roles"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 26": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {},
					"value": "appsettings"
				},
				"label": {
					"translations": {},
					"value": "App Settings"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 27": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Logout"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"index": 6
	},
	"aiAgents": {
		"Essay Analysis": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "envKey: GPT_API_TRANSCRIPT_ANALYSIS_KEY\ninput.essayText: [[essayText]]\ninput.essayPrompt: [[essayPrompt]]\ninstructions: Analyze input.essayText against input.essayPrompt.\n\nReturn only JSON matching the requested schema.\n\nScore the essay using these point buckets:\n- relevanceToPrompt+:+ 0-25\n- originalityAndInsight+:+ 0-20\n- writingQuality+:+ 0-15\n- personalStoryImpactMotivation+:+ 0-15\n\nessayScore.total must equal the sum of those four scores and must be 0-75.\n\nScores are raw weighted points, not 0-10 ratings.\nUse each category's full point range.\nSingle-digit scores mean weak performance unless the category maximum is near 10.\n\nFor each scoring category, provide notes of 1-2 sentences explaining the score.\nThe notes must match the score.\n\nFor relevanceToPrompt:\n- judge how directly and completely the essay answers the prompt\n- 22-25+:+ directly and completely answers the prompt\n- 17-21+:+ mostly answers the prompt with some missing depth, specificity, or focus\n- 10-16+:+ partially answers the prompt but misses important parts\n- 0-9+:+ mostly off-topic, missing, unreadable, or not responsive\n\nFor originalityAndInsight:\n- judge reflection, personal perspective, specificity, and meaningful reasoning\n- 17-20+:+ thoughtful, specific, reflective, and distinctive\n- 13-16+:+ solid insight but somewhat familiar, general, or predictable\n- 8-12+:+ limited originality or mostly surface-level reflection\n- 0-7+:+ generic, vague, repetitive, unsupported, or missing\n\nFor writingQuality:\n- judge clarity, organization, grammar, flow, and readability\n- 13-15+:+ clear, polished, organized, readable, and effective\n- 10-12+:+ mostly clear with some grammar, structure, flow, or repetition issues\n- 6-9+:+ understandable but noticeably rough, repetitive, or disorganized\n- 0-5+:+ difficult to read, incoherent, incomplete, or unreadable\n\nFor personalStoryImpactMotivation:\n- judge personal story, motivation, impact, concrete examples, and applicant-specific detail\n- 13-15+:+ strong personal story, motivation, impact, or future purpose\n- 10-12+:+ clear personal connection but could use more detail or depth\n- 6-9+:+ some personal connection but limited detail, impact, or motivation\n- 0-5+:+ little or no personal story, motivation, or applicant-specific detail\n\nreview.summary should briefly summarize the essay.\nreview.strengths should list the essay's strongest qualities.\nreview.concerns should list weaknesses, scoring concerns, missing details, or admin review issues.\n\nEvaluate possible AI-generated or heavily AI-assisted writing only as an admin review signal.\n\nFor aiGenerationReview:\n- concernScore+:+ 0-100\n- concernLevel+:+ low, medium, high, or unknown\n- reasons+:+ writing characteristics that caused the concern level\n- notes+:+ brief explanation, or null\n\nDo not claim the essay was AI-generated.\nDo not treat AI review as misconduct.\nDo not subtract points for possible AI generation.\nDo not include AI review in essayScore.total.\nDo not score GPA, transcript, essay length, profile photo, or other application components.\nDo not guess facts about the applicant.\nDo not include stray notes, internal thoughts, jokes, asides, or uncertainty fragments.\nUse warnings for missing prompt, missing essay, unreadable content, or anything that limits confidence.\n\nmodel: gpt-5.4-mini\ntext.format.name: essay_analysis_v6\ntext.format.schema.additionalProperties: false\ntext.format.schema.properties.aiGenerationReview.additionalProperties: false\ntext.format.schema.properties.aiGenerationReview.properties.concernLevel.enum.0: low\ntext.format.schema.properties.aiGenerationReview.properties.concernLevel.enum.1: medium\ntext.format.schema.properties.aiGenerationReview.properties.concernLevel.enum.2: high\ntext.format.schema.properties.aiGenerationReview.properties.concernLevel.enum.3: unknown\ntext.format.schema.properties.aiGenerationReview.properties.concernLevel.type: string\ntext.format.schema.properties.aiGenerationReview.properties.concernScore.maximum: 100\ntext.format.schema.properties.aiGenerationReview.properties.concernScore.minimum: 0\ntext.format.schema.properties.aiGenerationReview.properties.concernScore.type: integer\ntext.format.schema.properties.aiGenerationReview.properties.notes.type.0: string\ntext.format.schema.properties.aiGenerationReview.properties.notes.type.1: null\ntext.format.schema.properties.aiGenerationReview.properties.reasons.items.type: string\ntext.format.schema.properties.aiGenerationReview.properties.reasons.type: array\ntext.format.schema.properties.aiGenerationReview.required.0: concernScore\ntext.format.schema.properties.aiGenerationReview.required.1: concernLevel\ntext.format.schema.properties.aiGenerationReview.required.2: reasons\ntext.format.schema.properties.aiGenerationReview.required.3: notes\ntext.format.schema.properties.aiGenerationReview.type: object\ntext.format.schema.properties.essayScore.additionalProperties: false\ntext.format.schema.properties.essayScore.properties.originalityAndInsight.additionalProperties: false\ntext.format.schema.properties.essayScore.properties.originalityAndInsight.properties.notes.type.0: string\ntext.format.schema.properties.essayScore.properties.originalityAndInsight.properties.notes.type.1: null\ntext.format.schema.properties.essayScore.properties.originalityAndInsight.properties.score.maximum: 20\ntext.format.schema.properties.essayScore.properties.originalityAndInsight.properties.score.minimum: 0\ntext.format.schema.properties.essayScore.properties.originalityAndInsight.properties.score.type: integer\ntext.format.schema.properties.essayScore.properties.originalityAndInsight.required.0: score\ntext.format.schema.properties.essayScore.properties.originalityAndInsight.required.1: notes\ntext.format.schema.properties.essayScore.properties.originalityAndInsight.type: object\ntext.format.schema.properties.essayScore.properties.personalStoryImpactMotivation.additionalProperties: false\ntext.format.schema.properties.essayScore.properties.personalStoryImpactMotivation.properties.notes.type.0: string\ntext.format.schema.properties.essayScore.properties.personalStoryImpactMotivation.properties.notes.type.1: null\ntext.format.schema.properties.essayScore.properties.personalStoryImpactMotivation.properties.score.maximum: 15\ntext.format.schema.properties.essayScore.properties.personalStoryImpactMotivation.properties.score.minimum: 0\ntext.format.schema.properties.essayScore.properties.personalStoryImpactMotivation.properties.score.type: integer\ntext.format.schema.properties.essayScore.properties.personalStoryImpactMotivation.required.0: score\ntext.format.schema.properties.essayScore.properties.personalStoryImpactMotivation.required.1: notes\ntext.format.schema.properties.essayScore.properties.personalStoryImpactMotivation.type: object\ntext.format.schema.properties.essayScore.properties.relevanceToPrompt.additionalProperties: false\ntext.format.schema.properties.essayScore.properties.relevanceToPrompt.properties.notes.type.0: string\ntext.format.schema.properties.essayScore.properties.relevanceToPrompt.properties.notes.type.1: null\ntext.format.schema.properties.essayScore.properties.relevanceToPrompt.properties.score.maximum: 25\ntext.format.schema.properties.essayScore.properties.relevanceToPrompt.properties.score.minimum: 0\ntext.format.schema.properties.essayScore.properties.relevanceToPrompt.properties.score.type: integer\ntext.format.schema.properties.essayScore.properties.relevanceToPrompt.required.0: score\ntext.format.schema.properties.essayScore.properties.relevanceToPrompt.required.1: notes\ntext.format.schema.properties.essayScore.properties.relevanceToPrompt.type: object\ntext.format.schema.properties.essayScore.properties.total.maximum: 75\ntext.format.schema.properties.essayScore.properties.total.minimum: 0\ntext.format.schema.properties.essayScore.properties.total.type: integer\ntext.format.schema.properties.essayScore.properties.writingQuality.additionalProperties: false\ntext.format.schema.properties.essayScore.properties.writingQuality.properties.notes.type.0: string\ntext.format.schema.properties.essayScore.properties.writingQuality.properties.notes.type.1: null\ntext.format.schema.properties.essayScore.properties.writingQuality.properties.score.maximum: 15\ntext.format.schema.properties.essayScore.properties.writingQuality.properties.score.minimum: 0\ntext.format.schema.properties.essayScore.properties.writingQuality.properties.score.type: integer\ntext.format.schema.properties.essayScore.properties.writingQuality.required.0: score\ntext.format.schema.properties.essayScore.properties.writingQuality.required.1: notes\ntext.format.schema.properties.essayScore.properties.writingQuality.type: object\ntext.format.schema.properties.essayScore.required.0: relevanceToPrompt\ntext.format.schema.properties.essayScore.required.1: originalityAndInsight\ntext.format.schema.properties.essayScore.required.2: writingQuality\ntext.format.schema.properties.essayScore.required.3: personalStoryImpactMotivation\ntext.format.schema.properties.essayScore.required.4: total\ntext.format.schema.properties.essayScore.type: object\ntext.format.schema.properties.review.additionalProperties: false\ntext.format.schema.properties.review.properties.concerns.items.type: string\ntext.format.schema.properties.review.properties.concerns.type: array\ntext.format.schema.properties.review.properties.strengths.items.type: string\ntext.format.schema.properties.review.properties.strengths.type: array\ntext.format.schema.properties.review.properties.summary.type.0: string\ntext.format.schema.properties.review.properties.summary.type.1: null\ntext.format.schema.properties.review.required.0: summary\ntext.format.schema.properties.review.required.1: strengths\ntext.format.schema.properties.review.required.2: concerns\ntext.format.schema.properties.review.type: object\ntext.format.schema.properties.warnings.items.type: string\ntext.format.schema.properties.warnings.type: array\ntext.format.schema.required.0: essayScore\ntext.format.schema.required.1: review\ntext.format.schema.required.2: aiGenerationReview\ntext.format.schema.required.3: warnings\ntext.format.schema.type: object\ntext.format.strict: true\ntext.format.type: json_schema\n"
		},
		"Transcript Analysis": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "envKey: GPT_API_TRANSCRIPT_ANALYSIS_KEY\ninput: [[transcriptText]]\ninstructions: Extract transcript information from the provided transcript text.\n\nThe text may contain one transcript or multiple transcripts. Return one transcript object for each distinct transcript, school, university, institution, or transcript record found.\n\nExtract:\n- student names\n- schools, universities, districts, or issuing institutions\n- transcript level\n- student status or standing\n- student year or class year\n- graduation year\n- expected graduation date\n- transcript document dates\n- addresses\n- phone numbers\n- dates of birth\n- GPA values\n\nFor transcriptLevel:\n- use \"high_school\" for high school transcripts\n- use \"college\" for undergraduate college transcripts\n- use \"graduate\" for graduate-level transcripts\n- use \"unknown\" when not clearly shown\n\nFor schools:\n- include all clearly shown schools, universities, districts, or issuing institutions\n- use type \"high_school\", \"college\", \"university\", \"district\", \"institution\", or \"unknown\"\n\nFor addresses:\n- classify as \"student\", \"school\", \"parent_guardian\", \"other\", or \"unknown\"\n\nFor phones:\n- classify as \"student\", \"school\", \"fax\", \"parent_guardian\", \"other\", or \"unknown\"\n\nFor GPA values:\n- First look for GPA values explicitly reported on the transcript.\n- Preserve the transcript's GPA label as written when the GPA is reported.\n- Return the numeric GPA value.\n- Include the GPA scale only if clearly shown.\n- Include short nearby context for the GPA when available.\n- If no GPA is explicitly reported, but the transcript uses letter grades and includes enough completed course grades to estimate a GPA, calculate an estimated GPA and return it in gpas.\n- For calculated GPAs, use label \"Estimated GPA from letter grades\".\n- For calculated GPAs, set scale to 4 unless the transcript clearly shows a different GPA scale.\n- For calculated GPAs, explain the calculation briefly in context.\n- Add a warning when a GPA was calculated instead of reported.\n\nDo not calculate GPA from courses when a GPA is already reported on the transcript.\n\nIf no GPA is reported, you may calculate an estimated GPA from letter grades only when the transcript provides enough completed course-grade information.\n\nWhen calculating from letter grades:\n- Use the school's grading scale if it is clearly shown.\n- If no school grading scale is shown, use this standard 4.0 conversion:\n  A+ = 4.0\n  A = 4.0\n  A- = 3.7\n  B+ = 3.3\n  B = 3.0\n  B- = 2.7\n  C+ = 2.3\n  C = 2.0\n  C- = 1.7\n  D+ = 1.3\n  D = 1.0\n  D- = 0.7\n  F = 0.0\n- If credits, units, or attempted hours are clearly shown, calculate a credit-weighted GPA.\n- If credits, units, or attempted hours are not shown, calculate a simple unweighted average of completed letter-grade courses.\n- Do not include pass/fail, withdrawn, incomplete, audit, in-progress, transfer, repeated-excluded, or non-credit courses unless the transcript clearly includes them in GPA calculation.\n- Set label to \"Estimated GPA from letter grades\".\n- Set context to a short explanation of the calculation and whether it used credits/units or a simple average.\n- Add a warning that the GPA was estimated from letter grades and should be reviewed.\n- If the GPA cannot be calculated safely, return no GPA and add a warning.\n\nFor transcript document dates:\n- preserve the date text as shown in value\n- set isoDate to YYYY-MM-DD only when the full date is clearly shown\n- use null for isoDate when the date is partial, ambiguous, season-based, month/year only, or otherwise not safely normalizable\n- do not guess missing month, day, year, or century\n\nDo not guess.\nUse \"unknown\" for unknown enum fields.\nUse null for missing free-text fields.\nUse empty arrays when no values are found.\nmodel: gpt-5.4-mini\ntext.format.type: json_schema\ntext.format.name: transcript_analysis_v3\ntext.format.strict: true\ntext.format.schema.type: object\ntext.format.schema.additionalProperties: false\ntext.format.schema.properties.transcripts.type: array\ntext.format.schema.properties.transcripts.items.type: object\ntext.format.schema.properties.transcripts.items.additionalProperties: false\ntext.format.schema.properties.transcripts.items.properties.studentNames.type: array\ntext.format.schema.properties.transcripts.items.properties.studentNames.items.type: object\ntext.format.schema.properties.transcripts.items.properties.studentNames.items.additionalProperties: false\ntext.format.schema.properties.transcripts.items.properties.studentNames.items.properties.value.type: string\ntext.format.schema.properties.transcripts.items.properties.studentNames.items.properties.context.type.0: string\ntext.format.schema.properties.transcripts.items.properties.studentNames.items.properties.context.type.1: null\ntext.format.schema.properties.transcripts.items.properties.studentNames.items.required.0: value\ntext.format.schema.properties.transcripts.items.properties.studentNames.items.required.1: context\ntext.format.schema.properties.transcripts.items.properties.schools.type: array\ntext.format.schema.properties.transcripts.items.properties.schools.items.type: object\ntext.format.schema.properties.transcripts.items.properties.schools.items.additionalProperties: false\ntext.format.schema.properties.transcripts.items.properties.schools.items.properties.name.type: string\ntext.format.schema.properties.transcripts.items.properties.schools.items.properties.type.type: string\ntext.format.schema.properties.transcripts.items.properties.schools.items.properties.type.enum.0: high_school\ntext.format.schema.properties.transcripts.items.properties.schools.items.properties.type.enum.1: college\ntext.format.schema.properties.transcripts.items.properties.schools.items.properties.type.enum.2: university\ntext.format.schema.properties.transcripts.items.properties.schools.items.properties.type.enum.3: district\ntext.format.schema.properties.transcripts.items.properties.schools.items.properties.type.enum.4: institution\ntext.format.schema.properties.transcripts.items.properties.schools.items.properties.type.enum.5: unknown\ntext.format.schema.properties.transcripts.items.properties.schools.items.properties.context.type.0: string\ntext.format.schema.properties.transcripts.items.properties.schools.items.properties.context.type.1: null\ntext.format.schema.properties.transcripts.items.properties.schools.items.required.0: name\ntext.format.schema.properties.transcripts.items.properties.schools.items.required.1: type\ntext.format.schema.properties.transcripts.items.properties.schools.items.required.2: context\ntext.format.schema.properties.transcripts.items.properties.transcriptLevel.type: string\ntext.format.schema.properties.transcripts.items.properties.transcriptLevel.enum.0: high_school\ntext.format.schema.properties.transcripts.items.properties.transcriptLevel.enum.1: college\ntext.format.schema.properties.transcripts.items.properties.transcriptLevel.enum.2: graduate\ntext.format.schema.properties.transcripts.items.properties.transcriptLevel.enum.3: unknown\ntext.format.schema.properties.transcripts.items.properties.studentStatus.type.0: string\ntext.format.schema.properties.transcripts.items.properties.studentStatus.type.1: null\ntext.format.schema.properties.transcripts.items.properties.studentYear.type.0: string\ntext.format.schema.properties.transcripts.items.properties.studentYear.type.1: null\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.type: array\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.type: object\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.additionalProperties: false\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.type.type: string\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.type.enum.0: issued\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.type.enum.1: printed\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.type.enum.2: generated\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.type.enum.3: report\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.type.enum.4: updated\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.type.enum.5: as_of\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.type.enum.6: received\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.type.enum.7: official\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.type.enum.8: unknown\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.value.type: string\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.isoDate.type.0: string\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.isoDate.type.1: null\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.context.type.0: string\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.properties.context.type.1: null\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.required.0: type\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.required.1: value\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.required.2: isoDate\ntext.format.schema.properties.transcripts.items.properties.transcriptDates.items.required.3: context\ntext.format.schema.properties.transcripts.items.properties.graduationYear.type.0: string\ntext.format.schema.properties.transcripts.items.properties.graduationYear.type.1: null\ntext.format.schema.properties.transcripts.items.properties.expectedGradDate.type.0: string\ntext.format.schema.properties.transcripts.items.properties.expectedGradDate.type.1: null\ntext.format.schema.properties.transcripts.items.properties.addresses.type: array\ntext.format.schema.properties.transcripts.items.properties.addresses.items.type: object\ntext.format.schema.properties.transcripts.items.properties.addresses.items.additionalProperties: false\ntext.format.schema.properties.transcripts.items.properties.addresses.items.properties.type.type: string\ntext.format.schema.properties.transcripts.items.properties.addresses.items.properties.type.enum.0: student\ntext.format.schema.properties.transcripts.items.properties.addresses.items.properties.type.enum.1: school\ntext.format.schema.properties.transcripts.items.properties.addresses.items.properties.type.enum.2: parent_guardian\ntext.format.schema.properties.transcripts.items.properties.addresses.items.properties.type.enum.3: other\ntext.format.schema.properties.transcripts.items.properties.addresses.items.properties.type.enum.4: unknown\ntext.format.schema.properties.transcripts.items.properties.addresses.items.properties.value.type: string\ntext.format.schema.properties.transcripts.items.properties.addresses.items.properties.context.type.0: string\ntext.format.schema.properties.transcripts.items.properties.addresses.items.properties.context.type.1: null\ntext.format.schema.properties.transcripts.items.properties.addresses.items.required.0: type\ntext.format.schema.properties.transcripts.items.properties.addresses.items.required.1: value\ntext.format.schema.properties.transcripts.items.properties.addresses.items.required.2: context\ntext.format.schema.properties.transcripts.items.properties.phones.type: array\ntext.format.schema.properties.transcripts.items.properties.phones.items.type: object\ntext.format.schema.properties.transcripts.items.properties.phones.items.additionalProperties: false\ntext.format.schema.properties.transcripts.items.properties.phones.items.properties.type.type: string\ntext.format.schema.properties.transcripts.items.properties.phones.items.properties.type.enum.0: student\ntext.format.schema.properties.transcripts.items.properties.phones.items.properties.type.enum.1: school\ntext.format.schema.properties.transcripts.items.properties.phones.items.properties.type.enum.2: fax\ntext.format.schema.properties.transcripts.items.properties.phones.items.properties.type.enum.3: parent_guardian\ntext.format.schema.properties.transcripts.items.properties.phones.items.properties.type.enum.4: other\ntext.format.schema.properties.transcripts.items.properties.phones.items.properties.type.enum.5: unknown\ntext.format.schema.properties.transcripts.items.properties.phones.items.properties.value.type: string\ntext.format.schema.properties.transcripts.items.properties.phones.items.properties.context.type.0: string\ntext.format.schema.properties.transcripts.items.properties.phones.items.properties.context.type.1: null\ntext.format.schema.properties.transcripts.items.properties.phones.items.required.0: type\ntext.format.schema.properties.transcripts.items.properties.phones.items.required.1: value\ntext.format.schema.properties.transcripts.items.properties.phones.items.required.2: context\ntext.format.schema.properties.transcripts.items.properties.datesOfBirth.type: array\ntext.format.schema.properties.transcripts.items.properties.datesOfBirth.items.type: object\ntext.format.schema.properties.transcripts.items.properties.datesOfBirth.items.additionalProperties: false\ntext.format.schema.properties.transcripts.items.properties.datesOfBirth.items.properties.value.type: string\ntext.format.schema.properties.transcripts.items.properties.datesOfBirth.items.properties.context.type.0: string\ntext.format.schema.properties.transcripts.items.properties.datesOfBirth.items.properties.context.type.1: null\ntext.format.schema.properties.transcripts.items.properties.datesOfBirth.items.required.0: value\ntext.format.schema.properties.transcripts.items.properties.datesOfBirth.items.required.1: context\ntext.format.schema.properties.transcripts.items.properties.gpas.type: array\ntext.format.schema.properties.transcripts.items.properties.gpas.items.type: object\ntext.format.schema.properties.transcripts.items.properties.gpas.items.additionalProperties: false\ntext.format.schema.properties.transcripts.items.properties.gpas.items.properties.label.type: string\ntext.format.schema.properties.transcripts.items.properties.gpas.items.properties.value.type: number\ntext.format.schema.properties.transcripts.items.properties.gpas.items.properties.scale.type.0: number\ntext.format.schema.properties.transcripts.items.properties.gpas.items.properties.scale.type.1: null\ntext.format.schema.properties.transcripts.items.properties.gpas.items.properties.context.type.0: string\ntext.format.schema.properties.transcripts.items.properties.gpas.items.properties.context.type.1: null\ntext.format.schema.properties.transcripts.items.properties.gpas.items.required.0: label\ntext.format.schema.properties.transcripts.items.properties.gpas.items.required.1: value\ntext.format.schema.properties.transcripts.items.properties.gpas.items.required.2: scale\ntext.format.schema.properties.transcripts.items.properties.gpas.items.required.3: context\ntext.format.schema.properties.transcripts.items.properties.warnings.type: array\ntext.format.schema.properties.transcripts.items.properties.warnings.items.type: string\ntext.format.schema.properties.transcripts.items.required.0: studentNames\ntext.format.schema.properties.transcripts.items.required.1: schools\ntext.format.schema.properties.transcripts.items.required.2: transcriptLevel\ntext.format.schema.properties.transcripts.items.required.3: studentStatus\ntext.format.schema.properties.transcripts.items.required.4: studentYear\ntext.format.schema.properties.transcripts.items.required.5: graduationYear\ntext.format.schema.properties.transcripts.items.required.6: expectedGradDate\ntext.format.schema.properties.transcripts.items.required.7: addresses\ntext.format.schema.properties.transcripts.items.required.8: phones\ntext.format.schema.properties.transcripts.items.required.9: datesOfBirth\ntext.format.schema.properties.transcripts.items.required.10: gpas\ntext.format.schema.properties.transcripts.items.required.11: warnings\ntext.format.schema.properties.transcripts.items.required.12: transcriptDates\ntext.format.schema.properties.warnings.type: array\ntext.format.schema.properties.warnings.items.type: string\ntext.format.schema.required.0: transcripts\ntext.format.schema.required.1: warnings\n"
		},
		"index": 7
	},
	"cities": {
		"City 01": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Carlsbad"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/carlsbad/"
				}
			}
		},
		"City 02": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Chula Vista"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/chula-vista/"
				}
			}
		},
		"City 03": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Del Mar"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/del-mar/"
				}
			}
		},
		"City 04": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "El Cajon"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/el-cajon/"
				}
			}
		},
		"City 05": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Encinitas"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/encinitas/"
				}
			}
		},
		"City 06": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "La Jolla"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/la-jolla/"
				}
			}
		},
		"City 07": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Lemon Grove"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/lemon-grove/"
				}
			}
		},
		"City 08": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "National City"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/national-city/"
				}
			}
		},
		"City 09": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Oceanside"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/oceanside/"
				}
			}
		},
		"City 10": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Poway"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/poway/"
				}
			}
		},
		"City 11": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "San Diego"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/"
				}
			}
		},
		"City 12": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "San Marcos"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/san-marcos/"
				}
			}
		},
		"City 13": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Santee"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/santee/"
				}
			}
		},
		"City 14": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Solana Beach"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/solana-beach/"
				}
			}
		},
		"City 15": {
			"permission": "Admin",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Vista"
				},
				"link": {
					"translations": {},
					"value": "https://www.sevenslegal.com/ca/vista/"
				}
			}
		},
		"index": 8
	},
	"portalMenus": {
		"Menu 99": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Logout"
				},
				"path": {
					"translations": {},
					"value": "portal"
				}
			}
		},
		"index": 9
	},
	"socialMedia": {
		"index": 10,
		"title": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "Follow Us On"
		}
	},
	"submissionsMenus": {
		"Menu 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"cols": {
					"translations": {},
					"value": "submissions"
				},
				"endpoint": {
					"translations": {},
					"value": "submissions"
				},
				"label": {
					"translations": {},
					"value": "Submissions"
				},
				"path": {
					"translations": {},
					"value": "admin"
				}
			}
		},
		"Menu 99": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Logout"
				},
				"path": {
					"translations": {},
					"value": "portal"
				}
			}
		},
		"index": 11
	}
}